<template>
  <div class="pt-0" :class="{ 'scale-animation': !activityDate }">
    <router-link
      :disabled="disabled"
      class="button _shadow large outline"
      :class="{ 'bg-mist': activityDate }"
      :to="disabled ? '#' : 'dates/' + entityHierarchyKey"
      activeClass="active"
    >
      <span v-if="activityDate" class="flex">
        <span class="-text-medium">{{
          activityDate | moment("dddd, MMM DD")
        }}</span>
        <small class="text-blue">Edit</small>
      </span>
      <span class="text-blue" v-else>Select date</span>
    </router-link>
    <pre>disabled: {{ disabled }}</pre>
  </div>
</template>

<script>
export default {
  name: "DateUI",
  props: ["entityHierarchyKey", "activityDate", "disabled"]
};
</script>

<style></style>
